/**
 * 2023-08-11修复退款问题：
 * https://value.weike.fm/workbench/problemsystem/problem/detail?case_id=2834&caseflow_id=1&appid=ww48ee983b32b9b49d
 */

import React from 'react'
import axios from 'axios'
import qs from 'qs'
import {
    SearchBar, Cell, CellHeader, CellBody, CellFooter, LoadMore, Toast,
    ActionSheet, Toptips
} from 'react-weui'
import { connect } from 'react-redux'
import { WKTab, WKVisible, InfiniteScroll } from '../components'
import { WKOwnDialog, WKSearch } from '../components/wk'
import { toChatPage } from '../services'
import { TimeStream, renderMoney, getAccessToken, toDecimal2 } from '../utils'
import emptyImg from '../images/ban-no-item.png'
import '../css/page/DataCenterPayListPage.css'
import Refund from '../components/refund'
import { calculate } from '../utils/calculate'
import Config from "../config";

class DataCenterPayListPage extends React.Component {
    constructor(props) {
        super(props)
        this.applyRefundMenu = [{
            label: '同意退款',
            onClick: () => {
                const type = this.props.params.type
                const { isInRefundWhiteList, isPgc } = this.state
                if (type === 'channel' && isPgc) {
                    if (!isInRefundWhiteList) return this.showTip('请联系管理员开通操作权限')
                    this.setState({ isShowDetailedAgreeDialog: true, isShowAS: false })
                } else {
                    if (isPgc && !isInRefundWhiteList) return this.showTip('请联系管理员开通操作权限')
                    this.setState({ isShowAgreeDialog: true, isShowAS: false })
                }
            }
        }, {
            label: '拒绝退款',
            onClick: () => {
                this.setState({ isShowRejectDialog: true, isShowAS: false })
            }
        }]
        this.state = this.getInitState()
    }
    getInitState() {
        return {
            keyword: '',
            pays: null,
            refunds: null,
            paysOffset: 0,
            refundsOffset: 0,
            paysHasMore: true,
            refundsHasMore: true,
            isPaysPending: true,
            isRefundPending: true,
            selectedItem: {},
            isShowRejectDialog: false,
            isShowAgreeDialog: false,
            isShowAgreeReasonDialog: false,
            isShowPartialRefundDialog: false,
            isShowLoadingToast: false,
            // 详细版退款模态框，与isInRefundWhiteList白名单对应
            isShowDetailedAgreeDialog: false,
            rejectReason: '',
            agreeReason: '',
            partialRefundFee: '',  // 部分退款金额
            whitelist: [], //白名单列表
            totalFee: 0, //总金额
            feeWaring: false, //退款金额大于付款金额
            isShowAlertDialog: false,
            alertDialogText: '',
            menus: this.payMenu,
            isShowAS: false,
            isSuccessToast: false,
            successToastText: '',
            isSuccessRefundPending: false,
            successRefundsOffset: 0,
            successRefunds: null,
            successRefundsHasMore: true,
            isLiveroom: false,
            liveroomContext: null,
            isInRefundWhiteList: false,
            refundDetailedFormData: {},
            isRefundDetailedFormValidated: false,
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
            btnRefundBtnsAuth: {
                weike_h5_agree_refund: false,
                weike_h5_reject_refund: false
            },
            isPgc: false
        }
    }
    componentDidMount() {
        document.title = `${this.props.params.type === 'lecture' ? '课程' : this.props.params.type == 'channel' ? '专栏' : '直播间'}付费退款名单`
        this.initTab()
        this.fetchPays()
        this.fetchRefunds()
        this.fetchSuccessRefunds()
        // this.fetchWhitelist()
        // this.fetchRefundBtnShow()
        this.fetchLiveRoom().then(ctx => {
            ctx && this.fetchRefundWhiteList(ctx.liveroom.id)
            ctx && this.fetchLiveroomType(ctx.liveroom.id)
        })

    }
    showTip(text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    initTab() {
        const tab = this.props.location.query.tab
        let selectId = 1
        if (tab === 'refunding') {
            selectId = 2
        }
        if (tab === 'success') {
            selectId = 3
        }
        this.props.dispatch({
            type: 'COMPONENT_INIT_WKTAB',
            payload: {
                selectId,
                list: [{
                    name: '付费名单',
                    id: 1,
                    selected: true,
                }, {
                    name: '退款申请',
                    id: 2,
                }, {
                    name: '退款记录',
                    id: 3,
                }]
            }
        })
        this.props.dispatch({
            type: 'COMPONENT_SELECT_TAB',
            payload: selectId,
        })
    }
    onSearchSubmit() {
        this.setState({
            ...this.getInitState(),
            whitelist: this.state.whitelist,
            liveroomContext: this.state.liveroomContext,
            isInRefundWhiteList: this.state.isInRefundWhiteList,
            btnRefundBtnsAuth: this.state.btnRefundBtnsAuth,
            isPgc: this.state.isPgc,
            keyword: this.state.keyword
        }, () => {
            this.fetchPays()
            this.fetchRefunds()
            this.fetchSuccessRefunds()
        })
    }
    onCancel() {
        this.setState({
            ...this.getInitState(),
            whitelist: this.state.whitelist,
            isInRefundWhiteList: this.state.isInRefundWhiteList,
            btnRefundBtnsAuth: this.state.btnRefundBtnsAuth,
            isPgc: this.state.isPgc,
        }, () => {
            this.fetchPays()
            this.fetchRefunds()
            this.fetchSuccessRefunds()
        })
    }
    // 监听部分退款金额输入框
    inputChange(evt) {
        let obj = {}
        let value = evt.target.value
        value = (value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
        const flag = parseFloat(value) >= parseFloat(renderMoney(this.state.totalFee))
        if (flag) {
            value = null
            this.setState({ feeWaring: true })
        } else {
            this.setState({ feeWaring: false })
        }
        obj[evt.target.id] = value
        this.setState(obj)
    }
    fetchLiveRoom() {
        // 路由中type的值为channel或lecture或liveroom
        const { id, type } = this.props.params
        if (!id) return
        return axios.get(`/api/${type}/${id}/info?token=${getAccessToken()}`)
            .then(res => {
                const { liveroom, role } = res.data.data || {}
                // /api/liveroom/:id/info返回的role中，没有account_id字段，使用当前登录的用户id进行填充
                if (role.account_id === undefined) {
                    setTimeout(() => {
                        window.Session.getUserInfo().then(userInfo => {
                            this.setState(state => ({
                                liveroomContext: {
                                    ...state.liveroomContext,
                                    role: {
                                        ...state.liveroomContext.role,
                                        account_id: userInfo.id
                                    }
                                }
                            }))
                        })
                    }, 0);
                }
                const ctx = { liveroom, role }
                this.setState({ liveroomContext: ctx })
                return ctx
            })
    }
    // 获取退款权限白名单
    fetchRefundWhiteList(liveroom_id) {
        if (!this.state.liveroomContext) return
        const baseURL = Config.gateway_root_url
        return axios.get(`${baseURL}/config/whitelist_access_check`, {
            params: {
                server_name: 'weike',
                key: 'refund_whitelist',
                version: '1.0',
                liveroom_id,
                token: getAccessToken()
            }
        }).then(res => {
            if (res.data.data && res.data.data.can_access) {
                this.setState({
                    isInRefundWhiteList: res.data.data.can_access
                })
            }
        }).catch(err => {
            console.error(err)
        })
    }
    fetchRefundBtnShow(org_serial_no) {
        const params = { org_serial_no, resources_genre: 'api', resources_keys: ['weike_h5_reject_refund', 'weike_h5_agree_refund'] }
        return axios.post(`/v1/integration/wk_sys_acl/v1/wk_staff/org.user.batch_auth_by_resources_keys.check?token=${getAccessToken()}`, params,
            { baseURL: Config.BASE_URL_ELSE }
        ).then(res => {
            if (res.data.data && res.data.data.data_list) {
                const weike_h5_agree_refund = res.data.data.data_list.find(i => i.resources_key === 'weike_h5_agree_refund').auth
                const weike_h5_reject_refund = res.data.data.data_list.find(i => i.resources_key === 'weike_h5_reject_refund').auth
                this.setState({
                    btnRefundBtnsAuth: {
                        weike_h5_agree_refund,
                        weike_h5_reject_refund
                    }
                })
            }
        }).catch(err => {
            console.error(err)
        })
    }
    fetchLiveroomType(liveroom_id) {
        return axios.get(`/v1/integration/wk_staff/outer/organization.org_info_by_org_code.get?token=${getAccessToken()}&org_code=${liveroom_id}&sys_name=wk_staff`,
            { baseURL: Config.BASE_URL_ELSE }
        ).then(res => {
            if (res.data.data) {
                const { belong_to_pgc, id } = res.data.data
                this.setState({ isPgc: belong_to_pgc })
                this.fetchRefundBtnShow(id)
            }
        }).catch(err => {
            console.error(err)
        })
    }
    fetchPays(opts = {}) {
        this.setState({ isPaysPending: true })
        const { paysOffset, keyword } = this.state
        const type = this.props.params.type
        return axios.get(`/api/${type}/${this.props.params.id}/pay_refund_listeners`, {
            params: {
                refund_status: 'unrefund',
                q: keyword,
                ...(paysOffset === 0 ? {} : { offset: paysOffset }),
            }
        })
            .then(res => {
                this.setState({
                    pays: (this.state.pays || []).concat(res.data.data.listeners),
                    isPaysPending: false,
                    paysHasMore: res.data.data.has_more,
                    paysOffset: res.data.data.next_offset,
                })
                if (type === "liveroom") {
                    this.setState({
                        isLiveroom: true
                    })
                }
            })
        // }

    }
    fetchRefunds(opts = {}) {
        this.setState({ isRefundPending: true })
        const { refundsOffset, keyword } = this.state
        const type = this.props.params.type
        return axios.get(`/api/${type}/${this.props.params.id}/pay_refund_listeners`, {
            params: {
                refund_status: 'refunding',
                q: keyword,
                ...(refundsOffset === 0 ? {} : { offset: refundsOffset }),
            }
        })
            .then(res => {
                this.setState({
                    refunds: (this.state.refunds || []).concat(res.data.data.listeners),
                    isRefundPending: false,
                    refundsHasMore: res.data.data.has_more,
                    refundsOffset: res.data.data.next_offset,
                })
            })
    }
    fetchSuccessRefunds(opts = {}) {
        this.setState({ isSuccessRefundPending: true })
        const { successRefundsOffset, keyword } = this.state
        const type = this.props.params.type
        return axios.get(`/api/${type}/${this.props.params.id}/pay_refund_listeners`, {
            params: {
                refund_status: 'success',
                q: keyword,
                ...(successRefundsOffset === 0 ? {} : { offset: successRefundsOffset }),
            }
        })
            .then(res => {
                this.setState({
                    successRefunds: (this.state.successRefunds || []).concat(res.data.data.listeners),
                    isSuccessRefundPending: false,
                    successRefundsHasMore: res.data.data.has_more,
                    successRefundsOffset: res.data.data.next_offset,
                })
            })
    }
    onClickAvatar(uid, e) {
        e.stopPropagation()
        // location.assign(`/message/chat/${uid}`)
        toChatPage(uid)
    }
    onClickPayMore(item) {
        const { isInRefundWhiteList, btnRefundBtnsAuth, isPgc } = this.state
        if (!btnRefundBtnsAuth.weike_h5_agree_refund && !btnRefundBtnsAuth.weike_h5_reject_refund) {
            this.showTip('请联系管理员开通操作权限')
            return
        }
        const type = this.props.params.type
        const defaultMenu = {
            label: '退款',
            onClick: () => {
                // 特例
                const _isSpecialLiveroom = this.state.liveroomContext && this.state.liveroomContext.liveroom.id !== 23656502
                // 直播间创建者（也可以选择退款类型）
                if (type === 'channel' && isPgc && _isSpecialLiveroom) {
                    if (isInRefundWhiteList) {
                        this.setState({ isShowDetailedAgreeDialog: true, isShowAS: false })
                    } else {
                        this.showTip('请联系管理员开通操作权限')
                    }
                } else {
                    if (isPgc && !isInRefundWhiteList) {
                        this.showTip('请联系管理员开通操作权限')
                    } else {
                        this.setState({ isShowAgreeReasonDialog: true, isShowAS: false })
                    }
                }
            }
        }
        this.payMenu = [defaultMenu]
        this.setState({ isShowAS: true, selectedItem: item, menus: this.payMenu })
    }
    onClickApplyRefundMore(item) {
        const { btnRefundBtnsAuth } = this.state
        const agreeRefund = btnRefundBtnsAuth.weike_h5_agree_refund ? this.applyRefundMenu[0] : []
        const rejectRefund = btnRefundBtnsAuth.weike_h5_reject_refund ? this.applyRefundMenu[1] : []
        this.setState({ isShowAS: true, selectedItem: item, menus: [].concat(agreeRefund, rejectRefund) })
    }
    // 付款名单
    renderPay(item, index) {
        const isOwner = this.state.liveroomContext !== null && this.state.liveroomContext.liveroom.account_id === this.state.liveroomContext.role.account_id && item.can_not_refund !== '1'
        const isShowControlBtn = this.state.btnRefundBtnsAuth.weike_h5_reject_refund || this.state.btnRefundBtnsAuth.weike_h5_agree_refund || isOwner
        return (
            <Cell key={item.invoice_id ? item.invoice_id : index} access className="list-item">
                <CellHeader>
                    <div className="portrait" onClick={e => this.onClickAvatar(item.account.id, e)}>
                        <img src={item.account.small_avatar_url} />
                    </div>
                </CellHeader>
                <CellBody className='text-ellipsis detail'>
                    <p className='big-font nickname text-ellipsis'>{item.account.nickname}</p>
                    <p className='text-minor'>
                        <i>付款金额</i>
                        <span>{renderMoney(item.fee)}元</span>
                    </p>
                    <p className='text-minor'>
                        <i>付款时间</i>
                        <span>{TimeStream(item.pay_timestamp)}</span>
                    </p>
                    <WKVisible create={item.seller}>
                        <p className='text-minor text-ellipsis'>
                            <i>邀请人</i>
                            <span>{item.seller && item.seller.nickname}</span>
                        </p>
                    </WKVisible>
                </CellBody>
                {isShowControlBtn && (
                    <CellFooter className='more' onClick={e => this.onClickPayMore(item)}>
                        <div className="btn-control">操作</div>
                    </CellFooter>)
                }
            </Cell>
        )
    }
    renderPays(list) {
        if (!list) return null
        return list.map((item, index) => this.renderPay(item, index))
    }
    // 退款申请
    renderRefund(item, index) {
        const isAccessLectures = item.access_lectures && item.access_lectures.length > 0
        let reason = item.refund_reason.split(';')[0]
        let call = item.refund_reason.split(';')[1]
        const isOwner = this.state.liveroomContext !== null && this.state.liveroomContext.liveroom.account_id === this.state.liveroomContext.role.account_id
        const isShowControlBtn = this.state.btnRefundBtnsAuth.weike_h5_reject_refund || this.state.btnRefundBtnsAuth.weike_h5_agree_refund || isOwner

        return (
            <Cell key={item.invoice_id ? item.invoice_id : index} access className="list-item">
                <CellHeader>
                    <div className="portrait" onClick={e => this.onClickAvatar(item.account.id, e)}>
                        <img src={item.account.small_avatar_url} />
                    </div>
                </CellHeader>
                <CellBody className="detail">
                    <p className='big-font nickname'>{item.account.nickname}</p>
                    <p className='text-minor'>
                        <i>{this.props.params.type === 'channel' ? '专栏标题' : '课程标题'}</i>
                        <span className='text-info'>{(item.product_info && item.product_info.name) || '-'}</span>
                    </p>
                    <p className='text-minor'><i>退款原因</i><span>{reason || '无'}</span></p>
                    <p className='text-minor'><i>金额</i><span>{renderMoney(item.fee)}元</span></p>
                    {call &&
                        <p className='text-minor'>{call.replace(':', '：')}</p>
                    }
                    <WKVisible create={item.seller}>
                        <p className='text-minor'><i>邀请人</i><span>{item.seller && item.seller.nickname}</span></p>
                    </WKVisible>
                    <WKVisible create={isAccessLectures}>
                        <p className="text-minor">
                            <i>浏览记录</i><span>《{isAccessLectures && item.access_lectures[0].name}》等{isAccessLectures && item.access_lectures.length}节课</span>
                        </p>
                    </WKVisible>
                </CellBody>
                {isShowControlBtn && (
                    <CellFooter className='more'>
                        {
                            item.refund_status === 'applied' ? <div className="btn-control-gary">退款中</div> : <div className="btn-control" onClick={e => this.onClickApplyRefundMore(item)}>操作</div>
                        }
                    </CellFooter>
                )}
            </Cell>
        )
    }
    renderSuccessRefund(item, index) {
        const isAccessLectures = item.access_lectures && item.access_lectures.length > 0
        return (
            <Cell key={item.invoice_id ? item.invoice_id : index} access className="list-item refund-list-item">
                <CellHeader>
                    <div className="portrait" onClick={e => this.onClickAvatar(item.account.id, e)}>
                        <img src={item.account.small_avatar_url} alt="" />
                    </div>
                </CellHeader>
                <CellBody className="detail">
                    <p className='big-font nickname'>{item.account.nickname}</p>
                    <p className='text-minor'><i>{this.props.params.type === 'channel' ? '专栏标题' : '课程标题'}</i><span>{item.product_info && item.product_info.name || '-'}</span></p>
                    <p className='text-minor'><i>退款原因</i><span>{item.reason || '无'}</span></p>
                    <p className='text-minor'><i>备注</i><span>{item.refund_reason_remark || '无'}</span></p>
                    <p className='text-minor'><i>退款类型</i><span>{{
                        normal_refund: '普通退款',
                        all_refund: '全部退款',
                        partial_refund: '部分退款',
                        partial_refund_all_fee: '部分退款（不扣除手续费）',
                        refund_reject: '拒绝退款'
                    }[item.refund_type] || '-'}</span></p>
                    <p className='text-minor'><i>金额</i>
                        {
                            item.refund_type === undefined ?
                                (<span>{renderMoney(item.fee)}元</span>)
                                : (<span>{renderMoney(item.refund_type === 'all_refund' ? item.fee : (item.partial_refund_fee <= 0 ? item.fee : item.partial_refund_fee))}元</span>)
                        }
                    </p>
                    <div className="splitor"></div>
                    <p className='text-minor'><i>处理人</i><span>{item.refund_account_name || '-'}{item.refund_account_id && `（${item.refund_account_id}）`}</span></p>
                    <p className='text-minor'><i>处理时间</i><span>{
                        item.refund_time === 0 || item.refund_time === undefined
                            ? '-'
                            : TimeStream(item.refund_time)}</span></p>

                    <WKVisible create={item.seller}>
                        <p className='text-minor'><i>邀请人</i><span>{item.seller && item.seller.nickname}</span></p>
                    </WKVisible>
                    <WKVisible create={isAccessLectures}>
                        <p className="text-minor">
                            <i>浏览记录</i>
                            <span>《{isAccessLectures && item.access_lectures[0].name}》等{isAccessLectures && item.access_lectures.length}节课</span>
                        </p>
                    </WKVisible>
                </CellBody>
                <CellFooter>
                    <div className="slogan-container">
                        <img alt="" className="slogan"
                            src={require(`../images/refund/${item.refund_status_remark && item.refund_status_remark === 'fail' ? 'refund-fail' : item.refund_status === 'success' ? 'refund-success@3x' : 'reject-refund@3x'}.png`)} />
                    </div>
                </CellFooter>
            </Cell>
        )
    }
    renderRefunds(list) {
        if (!list) return null
        return list.map((item, index) => this.renderRefund(item, index))
    }
    renderSuccessRefunds(list) {
        if (!list) return null
        return list.map((item, index) => this.renderSuccessRefund(item, index))
    }
    // 确定同意退款
    handleClickAgreeOk() {
        this.setState({ isShowLoadingToast: true })
        const id = this.state.selectedItem.invoice_id
        axios.post(`/api/invoice/${id}/refund/agree`, qs.stringify({
            refund_type: 'normal_refund'
        }))
            .then(res => {
                if (res.data.code === 0) {
                    this.setState({
                        ...this.getInitState(),
                        whitelist: this.state.whitelist,
                        liveroomContext: this.state.liveroomContext,
                        isInRefundWhiteList: this.state.isInRefundWhiteList,
                        btnRefundBtnsAuth: this.state.btnRefundBtnsAuth,
                        isPgc: this.state.isPgc,
                        keyword: this.state.keyword
                    })
                    this.fetchRefunds()
                    this.fetchPays()
                    this.fetchSuccessRefunds()
                    this.showSuccessToast('退款成功')
                    this.toTab(3)
                } else {
                    this.showTip(res.data.msg)
                    this.setState({ isShowLoadingToast: false })
                }
            })
    }
    handleClickRejectOk() {
        const rejectReason = this.state.rejectReason.trim()
        if (rejectReason.trim() === '') {
            return this.showTip('理由不能为空')
        }
        this.setState({ isShowLoadingToast: true })
        const id = this.state.selectedItem.invoice_id
        axios.post(`/api/invoice/${id}/refund/reject`, qs.stringify({
            reason: this.state.rejectReason,
        }))
            .then(res => {
                if (res.data.code === 0) {
                    this.setState({
                        ...this.getInitState(),
                        whitelist: this.state.whitelist,
                        liveroomContext: this.state.liveroomContext,
                        isInRefundWhiteList: this.state.isInRefundWhiteList,
                        btnRefundBtnsAuth: this.state.btnRefundBtnsAuth,
                        isPgc: this.state.isPgc,
                        keyword: this.state.keyword
                    })
                    this.fetchRefunds()
                    this.fetchPays()
                    this.fetchSuccessRefunds()
                    this.showSuccessToast('已拒绝')
                } else {
                    this.setState({ isShowLoadingToast: false })
                    this.showTip(res.data.msg)
                }
            })
    }
    handleClickAlertOk() {
        this.setState({ isShowAlertDialog: false })
    }

    // 带退款类型的提交
    handleRefundDetailedFormClickOk() {
        const { refundDetailedFormData, isRefundDetailedFormValidated } = this.state
        const refundTypeValueFlag = refundDetailedFormData.selectedRefundTypeValue === 2 || refundDetailedFormData.selectedRefundTypeValue === 3
        if (refundTypeValueFlag && !isRefundDetailedFormValidated) return
        // 发请求确认退款，参考handleClickAgreeReasonOk
        const types = {
            0: 'normal_refund',
            1: 'all_refund',
            2: 'partial_refund',
            3: 'partial_refund_all_fee'
        }
        const id = this.state.selectedItem.invoice_id
        const cfg = {
            1: {
                url: `/api/invoice/${id}/refund/do`,
                params: {
                    refund_type: types[refundDetailedFormData.selectedRefundTypeValue],
                    fee: refundTypeValueFlag
                        ? calculate.mul(refundDetailedFormData.customRefund, 100)
                        : undefined,
                    reason: refundDetailedFormData.reason
                }
            },
            2: {
                url: `/api/invoice/${id}/refund/agree`,
                params: {
                    refund_type: types[refundDetailedFormData.selectedRefundTypeValue],
                    fee: refundTypeValueFlag
                        ? calculate.mul(refundDetailedFormData.customRefund, 100)
                        : undefined,
                    refund_reason_remark: refundDetailedFormData.reason
                }
            }
        }[this.props.selectId]

        if (!cfg) return
        axios.post(cfg.url, qs.stringify(cfg.params))
            .then(res => {
                if (res.data.code === 0) {
                    this.setState({
                        ...this.getInitState(),
                        whitelist: this.state.whitelist,
                        liveroomContext: this.state.liveroomContext,
                        isInRefundWhiteList: this.state.isInRefundWhiteList,
                        btnRefundBtnsAuth: this.state.btnRefundBtnsAuth,
                        isPgc: this.state.isPgc,
                        keyword: this.state.keyword
                    })
                    this.fetchRefunds()
                    this.fetchPays()
                    this.fetchSuccessRefunds()
                    this.showSuccessToast('退款成功')
                    this.toTab(3)
                } else {
                    this.showTip(res.data.msg)
                    this.setState({ isShowLoadingToast: false })
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    // 付费名单tab确定主动退款
    handleClickAgreeReasonOk(key) {
        const params = {
            reason: this.state.agreeReason,
            refund_type: 'normal_refund'
        }
        if (key) {
            const flag = this.state.feeWaring || !this.state.partialRefundFee || Number(this.state.partialRefundFee) === 0
            if (flag) {
                document.getElementById('partialRefundFee').focus()
                this.setState({ feeWaring: true })
                return
            }
            params.fee = Math.round(this.state.partialRefundFee * 100)  //需转成分传给后端
        }
        const id = this.state.selectedItem.invoice_id
        this.setState({ isShowLoadingToast: true })
        axios.post(`/api/invoice/${id}/refund/do`, qs.stringify(params))
            .then(res => {
                if (res.data.code === 0) {
                    this.setState({
                        ...this.getInitState(),
                        whitelist: this.state.whitelist,
                        liveroomContext: this.state.liveroomContext,
                        isInRefundWhiteList: this.state.isInRefundWhiteList,
                        btnRefundBtnsAuth: this.state.btnRefundBtnsAuth,
                        isPgc: this.state.isPgc,
                        keyword: this.state.keyword
                    })
                    this.fetchRefunds()
                    this.fetchPays()
                    this.fetchSuccessRefunds()
                    this.showSuccessToast('退款成功')
                    this.toTab(3)
                } else {
                    this.showTip(res.data.msg)
                    this.setState({ isShowLoadingToast: false })
                }
            })
    }
    toTab(id) {
        this.props.dispatch({
            type: 'COMPONENT_SELECT_TAB',
            payload: id,
        })
    }
    showSuccessToast(text) {
        this.setState({ isSuccessToast: true, successToastText: text })
        setTimeout(() => {
            this.setState({ isSuccessToast: false })
        }, 1000)
    }
    render() {
        const selectedNickname = this.state.selectedItem.account && this.state.selectedItem.account.nickname
        const { pays, refunds, successRefunds } = this.state
        return (
            <div className="wk-page datacenter-paylist-page">
                {/*搜索框  */}
                <div className="search-container">
                    <WKSearch
                        placeholder='请搜索用户昵称/ID'
                        lang={{
                            cancel: '取消'
                        }}
                        onChange={(text, e) => this.setState({ keyword: text })}
                        onSubmit={e => this.onSearchSubmit(e)}
                        onCancel={e => this.onCancel()}
                        defaultValue={this.state.keyword}
                    />
                </div>
                {/*tab  */}

                <WKTab />

                {/*用户列表  */}
                <div className="list-content">
                    <WKVisible show={+this.props.selectId === 1}>
                        {this.renderPays(this.state.pays)}
                        {this.state.isPaysPending && <div className="nomore-wrap"><LoadMore loading>正在加载</LoadMore></div>}
                        {pays && pays.length === 0 && <div className="empty-wrap"><img src={emptyImg} alt="" /><p>暂无付费名单</p></div>}
                    </WKVisible>
                    <WKVisible show={+this.props.selectId === 2}>
                        {this.renderRefunds(this.state.refunds)}
                        {this.state.isRefundPending && <div className="nomore-wrap"><LoadMore loading>正在加载</LoadMore></div>}
                        {refunds && refunds.length === 0 && <div className="empty-wrap"><img src={emptyImg} alt="" /><p>暂无退款申请</p></div>}
                    </WKVisible>
                    <WKVisible show={+this.props.selectId === 3}>
                        {this.renderSuccessRefunds(this.state.successRefunds)}
                        {this.state.isSuccessRefundPending && <div className="nomore-wrap"><LoadMore loading>正在加载</LoadMore></div>}
                        {successRefunds && successRefunds.length === 0 && <div className="empty-wrap"><img src={emptyImg} alt="" /><p>暂无退款记录</p></div>}
                    </WKVisible>
                </div>
                {/*退款理由dialog  */}
                <WKOwnDialog type="ios" title='退款理由'
                    buttons={[
                        { type: 'default', label: '取消', onClick: () => this.setState({ isShowAgreeReasonDialog: false, agreeReason: '' }) },
                        { type: 'primary', label: '确定', onClick: () => this.handleClickAgreeReasonOk() },
                    ]}
                    show={this.state.isShowAgreeReasonDialog}>
                    <textarea value={this.state.agreeReason} rows="6" placeholder='请输入退款理由（选填）'
                        onChange={e => this.setState({ agreeReason: e.target.value })}
                    >
                    </textarea>
                </WKOwnDialog>

                {/* 详细版退费 */}
                <WKOwnDialog
                    type="ios"
                    title={{
                        0: `是否同意【${selectedNickname}】的退款申请？`,
                        1: `是否对【${selectedNickname}】全额退款？`,
                        2: `是否对【${selectedNickname}】部分退款？`,
                        3: `是否对【${selectedNickname}】部分退款（不扣除手续费）？`
                    }[this.state.refundDetailedFormData.selectedRefundTypeValue]
                    }
                    buttons={[
                        {
                            type: 'default', label: '取消', onClick: () => {
                                this.setState({ isShowDetailedAgreeDialog: false })
                            }
                        },
                        { type: 'primary', label: '确定', onClick: () => this.handleRefundDetailedFormClickOk() },
                    ]}
                    show={this.state.isShowDetailedAgreeDialog}>
                    <Refund
                        onChange={({ form, isValidated }) => {
                            this.setState(state => ({
                                ...state,
                                isRefundDetailedFormValidated: isValidated,
                                refundDetailedFormData: form
                            }))
                        }}
                        nickname={selectedNickname}
                        amount={parseFloat(this.state.selectedItem.fee)} />
                </WKOwnDialog>

                {/* 部分退款理由 */}
                <WKOwnDialog type="ios" title='部分退款'
                    buttons={[
                        { type: 'default', label: '取消', onClick: () => this.setState({ isShowPartialRefundDialog: false, agreeReason: '', partialRefundFee: '', feeWaring: false }) },
                        { type: 'primary', label: '确定', onClick: () => this.handleClickAgreeReasonOk('N') },
                    ]}
                    show={this.state.isShowPartialRefundDialog}>
                    <div>
                        <div className="refund-fee-wraper">
                            <span className="label-name">退款金额：</span>
                            <input type="number"
                                placeholder="请输入要退款的金额"
                                id="partialRefundFee"
                                value={this.state.partialRefundFee || '请输入要退款的金额'}
                                onChange={this.inputChange.bind(this)}
                            />
                            <span>元</span>
                        </div>
                        {this.state.feeWaring && <div className="waring">退款金额必须低于付款金额且不能为0</div>}
                    </div>
                    <p className="tip">
                        将扣除1%手续费，学员实际收到退款：{toDecimal2((this.state.partialRefundFee * 100 - (Math.floor(this.state.partialRefundFee * 100 * 0.01))) / 100)}元
                    </p>
                    <textarea
                        value={this.state.agreeReason} rows="6" placeholder='请输入退款理由（选填）'
                        onChange={e => this.setState({ agreeReason: e.target.value })}
                    >
                    </textarea>
                </WKOwnDialog>

                {/*拒绝dialog  */}
                <WKOwnDialog type="ios" title={`拒绝【${selectedNickname}】的退款？`}
                    buttons={[
                        { type: 'default', label: '取消', onClick: () => this.setState({ isShowRejectDialog: false, rejectReason: '' }) },
                        { type: 'primary', label: '确定', onClick: () => this.handleClickRejectOk() },
                    ]}
                    show={this.state.isShowRejectDialog}>
                    <textarea value={this.state.rejectReason} rows="6" placeholder='点击此处，输入拒绝退款原因'
                        onChange={e => this.setState({ rejectReason: e.target.value })}
                    >
                    </textarea>
                </WKOwnDialog>
                {/*同意dialog  */}
                <WKOwnDialog type="ios" title={`同意【${selectedNickname}】的退款？`}
                    buttons={[
                        { type: 'default', label: '取消', onClick: () => this.setState({ isShowAgreeDialog: false }) },
                        { type: 'primary', label: '确定', onClick: () => this.handleClickAgreeOk() },
                    ]}
                    show={this.state.isShowAgreeDialog}>
                    <p className='text-minor normal-font'>退款将收取【{selectedNickname}】的 1% 手续费</p>
                </WKOwnDialog>
                {/* 错误提示  */}
                <WKOwnDialog type="ios" title='温馨提示' buttons={[{
                    label: '确定',
                    onClick: () => this.handleClickAlertOk(),
                }]} show={this.state.isShowAlertDialog}>
                    {this.state.alertDialogText}
                </WKOwnDialog>
                <Toast icon="loading" show={this.state.isShowLoadingToast}>请求中</Toast>
                <Toast icon="success-no-circle" show={this.state.isSuccessToast}>{this.state.successToastText}</Toast>
                <ActionSheet
                    menus={this.state.menus}
                    actions={[{
                        label: '取消',
                        onClick: e => this.setState({ isShowAS: false })
                    }]}
                    show={this.state.isShowAS}
                    type="ios"
                    onRequestClose={e => this.setState({ isShowAS: false })}
                />
                <InfiniteScroll
                    onTouchBottom={() => this.fetchPays()}
                    isStop={this.state.isPaysPending || +this.props.selectId !== 1}
                    isKill={!this.state.paysHasMore}
                />
                <InfiniteScroll
                    onTouchBottom={() => this.fetchRefunds()}
                    isStop={this.state.isRefundPending || +this.props.selectId !== 2}
                    isKill={!this.state.refundsHasMore}
                />
                <InfiniteScroll
                    onTouchBottom={() => this.fetchSuccessRefunds()}
                    isStop={this.state.isSuccessRefundPending || +this.props.selectId !== 3}
                    isKill={!this.state.successRefundsHasMore}
                />
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
            </div>
        )
    }
}


export default connect(state => ({
    selectId: state.component.wkTab.selectId,
}))(DataCenterPayListPage)



// WEBPACK FOOTER //
// ./src/pages/DataCenterPayListPage.js